export const PREDEFINED_MANIFEST_KEYS = [
    "name",
    "platform",
    "adType",
    "adSize",
    "reportingLabel",
    "backupQuality",
    "metadata",
    "hoxtonSettings",
    "disableLegacyCDN",
];

export const PREDEFINED_MANIFEST_REPORTING_LABEL_KEYS = ["language", "platform", "name", "adType", "width", "height"];
